

module.exports = [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "home" */ '@/views/HomeLayout.vue'),
        children: [
          {
            path: '/',
            alias: 'home',
            component: () => import(/* webpackChunkName: "home" */ '@/views/website/StartPage')
          },
          {
            path: 'impressum',
            alias: '/impressum',
            component: () => import(/* webpackChunkName: "legals" */ '@/views/website/ImpressumPage')
          },
          {
            path: 'datenschutz',
            alias: '/datenschutz',
            component: () => import(/* webpackChunkName: "legals" */ '@/views/website/DatenschutzPage')
          }
        ]
      }
]
